import { FlexCol, FlexRow } from '@/components/common/Flex';
import { LinkText } from '@/components/common/Typography';
import { Box, Collapse } from '@chakra-ui/react';
import { useState } from 'react';
import { Plus } from './icons';

interface QuestionAndAnswerProps {
    canOpenMultiple?: boolean;
    items: { question: string; answer: JSX.Element }[];
}

const QuestionAndAnswer = ({
    canOpenMultiple = false,
    items,
}: QuestionAndAnswerProps) => {
    const [openedIds, setOpenedIds] = useState<number[]>([]);

    const toggle = (id: number) => {
        setOpenedIds((prevIds) =>
            prevIds.includes(id)
                ? // Closing
                  prevIds.filter((prevId) => prevId !== id)
                : // Opening
                  canOpenMultiple
                  ? [...prevIds, id]
                  : [id]
        );
    };

    return (
        <FlexCol>
            {items.map(({ question, answer }, index) => {
                const isOpened = openedIds.includes(index);
                return (
                    <FlexCol key={index} mb={4}>
                        <FlexRow alignItems="center">
                            <LinkText
                                color="gray.700"
                                onClick={() => toggle(index)}
                                alignItems="center"
                            >
                                <FlexRow>
                                    <Plus
                                        // `transition` prop reserved for Framer
                                        style={{
                                            transition: 'all 200ms ease-out',
                                        }}
                                        transform={
                                            isOpened
                                                ? 'rotate(45deg)'
                                                : undefined
                                        }
                                        mt={1}
                                        mb={0.5}
                                        mr={2}
                                        color="blue.500"
                                        size="sm"
                                    />
                                    {question}
                                </FlexRow>
                            </LinkText>
                        </FlexRow>
                        <Collapse in={isOpened} animateOpacity>
                            <Box ml={4} mt={4}>
                                {answer}
                            </Box>
                        </Collapse>
                    </FlexCol>
                );
            })}
        </FlexCol>
    );
};

export default QuestionAndAnswer;
